import { render, staticRenderFns } from "./number-card.vue?vue&type=template&id=55475eb4&scoped=true&"
import script from "./number-card.vue?vue&type=script&lang=js&"
export * from "./number-card.vue?vue&type=script&lang=js&"
import style0 from "./number-card.vue?vue&type=style&index=0&id=55475eb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55475eb4",
  null
  
)

export default component.exports